export default "__VITE_ASSET__CqTFxqa4__"